import _ from 'lodash';
import jwt_decode from "jwt-decode";
import moment from 'moment';
import store from '../context/store/store';
import shortid from "shortid";
import { BellIconNotification, chatwindowDetails, contacts, contactwindowDetails, LoginState } from "../models/model";
import { Types } from '../context/action/action';
import { SocketChatService } from './socketChatService';
import { userInfo } from './socketChatService/utils';
import { unregister } from './callService/callService';
import { authSDK } from 'unifiedring-sdk';
import { config } from './constant';
import { toastInformation } from './callService/common';
import FileSaver from "file-saver";
import { showBrowserNotification } from './notification';
import { Blocknotifications } from '../components/blocknotifications/Blocknotifications';
import { eventService } from './eventService/event.service';
import { getMeetingByDate, getMeetingLists, getVideoRecordingLists } from './meetingService/apiService';
import axios from 'axios';
var JSZip = require("jszip");
var JSZipUtils = require("jszip-utils");

export const sortDate = (a: any, b: any) => {
    let dateAFormat: any = a && a.timestamp / 1000;
    let dateBFormat: any = b && b.timestamp / 1000;
    var dateA = new Date(parseFloat(dateAFormat));
    var dateB = new Date(parseFloat(dateBFormat));
    if (dateA > dateB) return -1;
    else if (dateA === dateB) return 0;
    else return 1;
};

export function getTimeFormat(time: any) {
    let formatDate: any = get_recent_date(time);
    time = formatDate.split(" ");
    if (time[4] === "Today") {
        time = time[2] + " " + time[3];
    } else if (time[4] === "Yesterday") {
        time = "Yesterday";
    } else {
        time = time[1];
    }
    return time;
};

export const bytesToSize = (bytes: any) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (i === 0) return `${bytes} ${sizes[i]}`;
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
};

export const handleDatePickers = (e: any, neededArray: any) => {
    let startDate = moment(e[0]._d).format("X");
    let EndDate = moment(e[1]._d).format("X");
    if (startDate === EndDate) {
        return _.filter(neededArray, ((data: any) => {
            let date = Date.parse(moment(data.dtstart * 1000).format('MM/DD/YYYY'));
            return date === Date.parse(moment(e[0]._d).format('MM/DD/YYYY'));

        }));
    } else {

        return _.filter(neededArray, ((data: any) => {
            let date = Date.parse(moment(data.dtstart * 1000).format('MM/DD/YYYY'));
            return date >= Date.parse(moment(e[0]._d).format('MM/DD/YYYY')) &&
                date <= Date.parse(moment(e[1]._d).format('MM/DD/YYYY'));;
        }));
    }
};

export const Logout = () => {
    const token: any = Cookie.get();
    let tokenData: any = token["ssoToken"];
    // console.log(config().APPID,"SSO TOKEN --->", tokenData);
    return new authSDK.SSORestService().logOut({
        appId: config().APPID,
        appSecret: config().AppSECRET,
        Authorization: tokenData
    })
}
export const handleNoteCalender = (e: any, neededArray: any) => {

    let startDate = moment(e[0]._d).format("X");
    let EndDate = moment(e[1]._d).format("X");
    if (startDate === EndDate) {
        return _.filter(neededArray, ((data: any) => {
            let date = Date.parse(moment(parseInt(data.lastModified)).format('L'));
            return date === Date.parse(moment(e[0]._d).format('MM/DD/YYYY'));

        }));
    } else {
        return _.filter(neededArray, ((data: any) => {
            let date = Date.parse(moment(parseInt(data.lastModified)).format('L'));
            return date >= Date.parse(moment(e[0]._d).format('MM/DD/YYYY')) &&
                date <= Date.parse(moment(e[1]._d).format('MM/DD/YYYY'));;
        }));

    }

};
export function get_recent_date(stamp: any) {

    const day: any = new Date(stamp);
    const min = day.getMinutes().toString().padStart(2, "0");
    const Bdate = day.getHours() + ":" + min;

    let time: any = Bdate.split(" ");
    let ampm: any;

    let [hours, minutes] = time[0].split(":");
    ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    time = hours + ":" + minutes + " " + ampm;

    let month: any = parseInt(day.getMonth()) + 1;
    let date =
        day.getDate().toString().length > 1 ? day.getDate() : "0" + day.getDate();
    month = month.toString().length > 1 ? month : "0" + month;
    let year = day.getFullYear();
    let newdate = date + "/" + month + "/" + year;

    var days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];

    const curDate = new Date();
    const Cdate =
        curDate.getDate() +
        "-" +
        (curDate.getMonth() + 1) +
        "-" +
        curDate.getFullYear();


    const Ydate =
        curDate.getDate() -
        1 +
        "-" +
        (curDate.getMonth() + 1) +
        "-" +
        curDate.getFullYear();
    var Tdate =
        day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
    var group = Tdate;

    if (Cdate.trim() === Tdate.trim()) group = "Today";
    else if (Ydate === Tdate) group = "Yesterday";

    return days[day.getDay()] + " " + newdate + " " + time + " " + group;
}
export function getcontactDetail(receiver: any, contactList?: any, loggedUser?: any) {

    let {
        userdetails
    }: LoginState = store.getState().loginReducer;
    let {
        allContacs
    }: contacts = store.getState().contactReducer;

    contactList = allContacs;
    loggedUser = userdetails;

    if (receiver && receiver.toString().includes("con")) {
        return contactList.find((List: any) => List.team_id && List.team_id.toString() === receiver.slice(3));
    } else {
        if (loggedUser?.sip_login_id.toString() === receiver) {
            return {
                caller_id: loggedUser.caller_id,
                ext: loggedUser.ext,
                email_id: loggedUser.Email,
                ImageURL: loggedUser.profile_url,
                jid: `${loggedUser.sip_login_id}@${loggedUser.host_address}`,
                sip_login_id: loggedUser.sip_login_id,
                isLoggedUser: true
            };
        }
        return contactList?.find((List: any) => List?.sip_login_id && List?.sip_login_id.toString() === receiver);
    }
}
export const sortByTimeStamp = (failed: any) => {
    let timeStampDetails = 0;
    const initialArray: any = {};
    for (var i = 0; i < failed.length; i++) {
        if (timeStampDetails === 0) {
            timeStampDetails = failed[0].timestamp;
            initialArray[timeStampDetails] = [];

        }
        if (timeStampDetails) {
            var duration = moment.duration(moment(failed[i].timestamp).diff(timeStampDetails)).asMinutes();

            if (duration < 5) {
                if (initialArray[timeStampDetails] !== undefined) {
                    initialArray[timeStampDetails].push(failed[i]);
                }
                //initialArray[timeStampDetails].push(failed[i]);
                // if(initialArray[initialArray.length-1] && initialArray[initialArray.length-1].length===0) {
                //   initialArray[initialArray.length-1] = [];
                // }
                // if(Array.isArray(initialArray[initialArray.length-1])){
                //   console.log(initialArray,'Duration1111 ---->',initialArray[initialArray.length-1]);
                //    initialArray[initialArray.length-1].push(val);
                //    console.log('Duration111112 ---->',initialArray[initialArray.length-1]);
                // } 
            } else {
                timeStampDetails = failed[i].timestamp;
            }
        }
    }
    return initialArray;
}
export const getTeamMemberContact = (receiver: any, workContact?: any, loggedUser?: any) => {
    let contactObject: any = store.getState().contactReducer;
    workContact = contactObject?.workContactsnew;
    if (workContact[receiver]) {
        let chatUser: any = workContact[receiver];
        return chatUser;
    }
}
export function getFileSize(fileSize: any) {
    if (fileSize === 0) return '0 Byte';
    let decimals: any = 1;
    let k = 1024;
    let dm = decimals + 1 || 3;
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = Math.floor(Math.log(fileSize) / Math.log(k));
    return fileSize = parseFloat((fileSize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
export async function setCookie(cName: string, cValue: any, expDays: number) {

    //expDays in days
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}


export function getCookie(cName: string) {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    });


    return res;
}


export function compareName(a: any, b: any) {

    try {

        var tempA = a?.caller_id || a?.team_name;
        var tempB = b?.caller_id || b?.team_name;



        tempA = tempA.toUpperCase().trim();
        tempB = tempB.toUpperCase().trim();

        if (tempA < tempB) return -1;
        if (tempA > tempB) return 1;

        return 0;
    } catch (error) {
        console.log("error", error);
    }

}

export function groupbyday(data: any) {
    const groups =
        data &&
        data.reduce((groups: any, game: any) => {
            let date: any = get_recent_date(game.timestamp);

            date = date.split(" ");
            date = date[4];
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(game);
            return groups;
        }, {});

    const groupArrays = Object.keys(groups).map((date) => {
        return {
            date,
            messageArray: groups[date]
        };
    });
    return groupArrays;
}

export function groupSavedChatbyday(data: any) {
    const groups =
        data &&
        data.reduce((groups: any, game: any) => {
            let date: any = get_recent_date(game.timeStamp);

            date = date.split(" ");
            date = date[4];
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(game);
            return groups;
        }, {});

    const groupArrays = Object.keys(groups).map((date) => {
        return {
            date,
            messageArray: groups[date]
        };
    });
    return groupArrays;
}


export const getParseData = (type: any, response: any) => {

    let recentArray: any = [];
    response.sort(sortDate);
    response.map((recent: any) => {
        let parser = new DOMParser();

        let xmlDoc: any = parser.parseFromString(recent.message, "text/xml");


        let summary: string = "";
        let title: string = "";
        let msgType: string = "";
        let replyText: any = "";
        let msgText: string = "";
        let msgId: any = "";
        let receiver: any = "";
        let sender: any = "";
        let timeStamp: any = recent.timestamp;


        if (xmlDoc.getElementsByTagName("urlLink").length > 0) {
            summary = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("summary");
            title = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("title");
        }

        let time: any = moment(recent.timestamp).format('YYYY/MM/DD');

        if (xmlDoc.getElementsByTagName("message").length > 0) {

            let fromUser: any = xmlDoc.getElementsByTagName("message")[0].getAttribute("from");
            let toUser: any = xmlDoc.getElementsByTagName("message")[0].getAttribute("to");

            receiver = fromUser.split("/")[0];
            sender = toUser.split("/")[0];
            msgId = xmlDoc.getElementsByTagName("message")[0].getAttribute("id");

        }

        receiver = receiver && receiver.split("@")[0];
        sender = sender && sender.split("@")[0];


        let fromcaller_details = getUserNameForTeam(receiver);

        let tocaller_details = getUserNameForTeam(sender);

        if (xmlDoc.getElementsByTagName("body").length > 0) {
            if (xmlDoc.getElementsByTagName("reply").length > 0) {

                replyText = xmlDoc.getElementsByTagName("reply")[0].childNodes[0].nodeValue;
                msgText = xmlDoc.getElementsByTagName("body")[0].childNodes[0].nodeValue;

            } else {
                let body = xmlDoc.getElementsByTagName("body")[0].childNodes[0].nodeValue;
                msgText = body;
            }
        } else {
            msgText = "";
        }

        if (xmlDoc.getElementsByTagName("message-type").length > 0) {
            msgType = xmlDoc.getElementsByTagName("message-type")[0].getAttribute("value");

        } else if (xmlDoc.getElementsByTagName("subject").length > 0) {
            msgType = xmlDoc.getElementsByTagName("subject")[0].childNodes[0].nodeValue;
        } else {
            msgType = "TEXT";
        }

        let recentJson = {
            summary,
            title,
            msgType,
            msgText,
            replyText,
            receiver,
            fromcaller_details,
            tocaller_details,
            msgId,
            timeStamp,
            time,
            sender

        };

        recentArray.push(recentJson);

    });
    return recentArray;
};

export function ParseRecentFilterData(response: any, type: any) {

    let {
        userdetails
    } = store.getState().loginReducer;
    let {
        sip_login_id
    } = userdetails;
    let {
        allContacs
    }: contacts = store.getState().contactReducer;
    let recentArray: any = [];
    let {
        contactLinkLength,
        isLinkPaginationStop,
        contactSavedLength,
        isStopPagination
    }: contactwindowDetails = store.getState().contactWindowReducer;
    response.sort(sortDate);
    response.map((recent: any) => {
        if (recent === null || recent === undefined) return null;
        let parser = new DOMParser();
        let xmlDoc: any = parser.parseFromString(recent.message, "text/xml");

        if (xmlDoc.getElementsByTagName("body").length === 0) {
            return null;
        }

        let receiver: any = "";
        let replyText: any = "";
        let body_text: string = "";
        let message_type_value: string = "";
        let name: string = "unknown sender";
        let image: string = "";
        let presence: string = "Invisible";
        let ext: string = "";
        let fileSize: any = "";
        let timeStamp: any = recent.timestamp;
        let fileType: any = "";
        let fileName: any = "";
        let summary: string = "";
        let title: string = "";
        let id: any = "";
        let filedetails_text: any = "";
        let isBookmark: any = "";
        let likedUser: any = [];
        let isLike: any = false;
        let unReadCount: any = recent?.unread_count ? recent?.unread_count : 0;
        let isReply: boolean = false;
        let toUser: any = '';
        let isLink: boolean = false;
        let likeduserdetails: any = [];
        let likedUserNames: any = [];

        let time: any = moment(recent.timestamp).format('hh:mm A');
        let displayTime: any = moment(recent.timestamp).format('hh:mm');
        if (xmlDoc.getElementsByTagName("message").length > 0) {

            let fromUser: any = xmlDoc.getElementsByTagName("message")[0].getAttribute("from");
            receiver = fromUser.split("/")[0];
            toUser = xmlDoc.getElementsByTagName("message")[0].getAttribute("to");
            id = xmlDoc.getElementsByTagName("message")[0].getAttribute("id");

        }
        if (xmlDoc.getElementsByTagName("urlLink").length === 0) {
            isLink = true;
        }
        if (xmlDoc.getElementsByTagName("save").length > 0) {
            isBookmark = true;
        }

        if (xmlDoc.getElementsByTagName("like").length > 0) {

            likedUser = xmlDoc.getElementsByTagName("like")[0].childNodes.length > 0 ?
                xmlDoc.getElementsByTagName("like")[0].childNodes[0].nodeValue : "";


            if (likedUser === "") likedUser = [];
            else {

                likedUser = likedUser.split(",");
                likedUser.map((id: any) => {

                    if (id === sip_login_id.toString()) isLike = true;
                    let contact_det = getcontactDetail(id, allContacs, userdetails);

                    likedUserNames.push(contact_det?.caller_id);
                });

                likeduserdetails = likedUserNames.join(",");
            }

        }


        receiver = receiver && receiver.split("@")[0];


        let fromcaller_details = getUserNameForTeam(receiver);
        let tocaller_details = getUserNameForTeam(toUser.split("@")[0]);
        let contactDetail: any = getcontactDetail(receiver, allContacs, userdetails);

        if (contactDetail === undefined) return;

        let teamId: any = fromcaller_details?.team_id ? true : false;

        name = contactDetail.sip_login_id ? contactDetail.caller_id : contactDetail.team_name || "unknown sender";
        image = contactDetail.ImageURL || contactDetail.profile_image_url || contactDetail.profile_url || "";
        presence = contactDetail.user_status;
        ext = contactDetail.ext || "";

        if (name.length > 28) {
            name = name.substring(0, 28) + "...";
        }
        /*     if (xmlDoc.getElementsByTagName("filedetails").length > 0) {
              fileSize = xmlDoc.getElementsByTagName("filedetails")[0]?.childNodes[0]?.nodeValue;
              console.log(fileSize,"------------->>");
            } */
        if (xmlDoc.getElementsByTagName("body").length > 0) {
            if (xmlDoc.getElementsByTagName("reply").length > 0) {
                isReply = true;
                replyText = xmlDoc.getElementsByTagName("reply")[0]?.childNodes[0]?.nodeValue;
                body_text = xmlDoc.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;

            } else {
                let body = xmlDoc.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;
                body_text = body;
            }
        } else {
            body_text = "";
        }
        if (body_text === "This message was deleted") return;


        if (xmlDoc.getElementsByTagName("message-type").length > 0) {
            message_type_value = xmlDoc.getElementsByTagName("message-type")[0].getAttribute("value");

        } else if (xmlDoc.getElementsByTagName("subject").length > 0) {
            message_type_value = xmlDoc.getElementsByTagName("subject")[0]?.childNodes[0]?.nodeValue;
        } else {
            message_type_value = "TEXT";
        }


        let downloadLink = body_text;
        if (xmlDoc.getElementsByTagName("urlLink").length > 0) {
            summary = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("summary");
            title = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("title");
        }

        if (xmlDoc.getElementsByTagName("broadcast").length > 0) {
            if (xmlDoc.getElementsByTagName("delay").length > 0) return true;

            let createdUser: any = xmlDoc.getElementsByTagName("message")[0].getAttribute("from");
            let body = xmlDoc.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;

            if (createdUser !== null && createdUser !== undefined) {
                let BrodCastMessage = JSON.parse(body);
                if (createdUser.includes(sip_login_id.toString())) {
                    body_text = BrodCastMessage.body2;
                } else {
                    body_text = BrodCastMessage.body1;
                }
            }

        }


        if (xmlDoc.getElementsByTagName("filedetails").length > 0) {

            let fileAttribute: any = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileSize');

            if (fileAttribute) {

                fileSize = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileSize');
                fileName = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileName');


            } else {

                if (xmlDoc.getElementsByTagName("filedetails")[0]?.childNodes[0]) {
                    let contentfileSize = xmlDoc.getElementsByTagName("filedetails")[0]?.childNodes[0]?.nodeValue;



                    fileSize = contentfileSize.split("||")[0];

                    let filenameContent: any = body_text.split("/");
                    let filenameFinal: any = filenameContent.splice(-1);


                    fileName = filenameFinal[0];
                } else {
                    fileSize = 0;
                    fileName = "";
                }

            }


            if (fileSize === 0) return '0 Byte';
            let decimals: any = 1;
            let k = 1024;
            let dm = decimals + 1 || 3;
            let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let i = Math.floor(Math.log(fileSize) / Math.log(k));
            fileSize = parseFloat((fileSize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
        if (message_type_value === 'FILE') {
            let filename: any = body_text.split("/");
            let filenameFinal: any = filename.splice(-1);
            let filext: any = filenameFinal.toString().split(".").splice(-1);
            fileType = filext[0];
            // fileName = filenameFinal[0];

        }
        let recentJson = {
            message_type_value,
            isLink,
            body_text,
            replyText,
            name,
            presence,
            ext,
            contactDetail,
            image,
            timeStamp,
            time,
            receiver,
            teamId,
            likedUserNames,
            fileType,
            fileName,
            summary,
            title,
            fileSize,
            id,
            fromcaller_details,
            tocaller_details,
            downloadLink,
            filedetails_text,
            isBookmark,
            likedUser,
            isLike,
            isReply,
            displayTime,
            unReadCount,
            likeduserdetails
        };

        recentArray.push(recentJson);
    });
    store.dispatch({
        type: Types.CONTACT_LINK_LOAD,
        payload: {
            isLinkChatLoad: false,
            contactLinkLength: contactLinkLength,
            isLinkPaginationStop: isLinkPaginationStop
        }
    });
    store.dispatch({
        type: Types.CONTACT_SAVED_LOAD,
        payload: {
            isSaveChatLoad: false,
            contactSavedLength: contactSavedLength,
            isStopPagination: isStopPagination
        }
    });
    return recentArray;
}
export function create_UUID() {
    var dt = new Date().getTime();
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
    );
    return uuid;
}
export const fileFormat = ["pdf", "xls", "xlsx", "xlsm", "xlsb", "xml", "wbk", "dotm", "docb", "doc", "docx", "wpd", "rtf", "dif", "prn", "ppt", "pptx", "ppsx", "sldm", "potx", "sldx", "mp3", "m4a", "flac", "wav", "aac", "alac", "zip", "7z", "jar", "rar", "wim", "cpt", "viv", "cpt", "ace", "flv", "vob", "nsv", "drc", "avchd", "xlsb", "xla", "xlam", "xlsm", "xlt", "application/vnd.google-apps.spreadsheet", "xltm", "xltx", "xlw", "xll", "csv", "docb", "dotx", "docm", "wbk", "odt", "txt", "potm", "ppsx", "potm", "ppam", "arj", "cab", "cfs", "dar", "war", "kgb", "txz", "dd", "ear", "cfs", "yz1", "3gp", "ogg", "ogx", "wmv", "ogv", "rm", "rmvb", "asf", "mpga", "wma", "aif", "aifc", "htm", "aiff", "html"];

export const imageFormat = ["PNG", "jpeg", "jpg", "svg", "gif", "webp", 'png', "jfif", "ico", "tiff", "jfif", "nef", "orf", "dib", "eps", "raw", "heif", "apng", "avif", "jif", "tif", "xbm", "heic", "arw", "image/png",
    "image/jpeg", "image/jpg", "image/gif", "image/jfif", "image/heif", "application/octet-stream", "image/svg", "image/webp", "image/gif", "image/svg+xml"
];
export const strickerFormat = ["webp", "image/svg", "image/webp"];
export const gifFormat = ["gif", "image/gif"];
export const imageforpreview = [
    "PNG", "jpeg", "jpg", "svg", 'png', "jfif", "ico", "tiff", "jfif", "nef", "orf", "dib", "eps", "heif"
];

export const imageFormatType = ["image/png", "image/jpeg", "image/jpg", "image/jfif", "image/svg", "image/webp", "image/gif", "image/svg+xml"];

export const videoFormat = ["mp4", "video/mp4", "video/webm", "video/quicktime", "mov", "3gp", "video/3gpp", "video/x-ms-wmv", "video/x-msvideo", "video/x-flv", "ogg", "ogx", "wmv", "webm", "flv", "avi"];

export const excelFormats = ["xla", "xlam", "xls", "xlsb", "xlsm", "application/vnd.ms-excel",
    "xlsx", "application/vnd.google-apps.spreadsheet", "xlt",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xltm", "xltx", "xlw", "csv", "application/vnd.ms-excel", "xll",
    'XLSX', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"
];
export const pptFormats = ["ppt", "pptx", "pptm", "potx", "potm", "ppam", "ppsx", "ppsm", "sldx", "sldm ", 'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
export const wordFormats = ["docx", "dot", "doc", "text/plain",
    "dotm", "txt", "wpd", "odt", "wbk", "docm", "dotx", "docb", "rtf", "prn", "dif", "slk", "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "application/vnd.ms-word.document.macroEnabled.12",
    "application/vnd.ms-word.template.macroEnabled.12"
];
export const wordMimeFormats = ["application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "application/vnd.ms-word.document.macroEnabled.12",
    "application/vnd.ms-word.template.macroEnabled.12"
];
export const pptMimeFormats = ['application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
export const excelMimeFormats = ["application/vnd.ms-excel", "text/csv",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "application/vnd.google-apps.spreadsheet",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-excel.template.macroEnabled.12",
    "application/vnd.ms-excel.addin.macroEnabled.12",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
];
export const zipMimeFormats = ["application/zip", "application/octet-stream", "application/x-zip-compressed",
    "application/x-zip-compressed", "multipart/x-zip", "application/x-rar-compressed", "application/octet-stream", "application/x-gzip"
];
export const zipFormats = ["zip", "arj", "cab", "cfs", "application/x-zip-compressed", "cpt", "dar", "dmg", "war", "kgb", "txz", "dd", "ear", "wim", "jar", "rar", "yz1", "application/x-gzip", "application/zip", "application/octet-stream", "application/x-zip-compressed",
    "application/x-zip-compressed", "multipart/x-zip", "application/x-rar-compressed", "application/octet-stream", "application/x-gzip"
];
export const mp3Formats = ["mp3", "mpga", "wma", "ogg", "aif", "aifc", "aiff", "m4a", "aac", "audio/aac", "audio/wav", "audio/wave", "wav", "audio/mpeg", "audio/mp3"];
export const allFormats = ["xls", "xlsx", "xla", "xlt", "xml", "pptm", "xlw", "xltm", "pptx", "xlam", "xll", "aac", "csv", "zip", "arj", "cab", "cfs", "cpt", "dar", "dmg", "war", "kgb", "txz", "dd", "ear", "wim", "jar", "rar", "yz1", "ppt", "potx", "potm", "ppam", "ppsx", "sldx", "m4a", "ppsm", "sldm", "pdf", "docx", "dot", "doc", "dotm", "txt", "wpd", "odt", "wbk", "docm", "dotx", "docb", "rtf", "prn", "dif", "slk", "wav", "mp3", "mpga", "wma", "ogg", "aif", "aifc", "aiff", "htm", "html", "audio/mp3"];

export const pdfFormats = ["pdf", "application/pdf"];

export const imageFormatFormExt: any = (ext: any) => {
    let imgType = "";
    switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "ico":
        case "tiff":
        case "webp":
        case "jfif":
        case "nef":
        case "orf":
        case "dib":
        case "eps":
        case "raw":
        case "heif":
        case "apng":
        case "avif":
        case "jif":
        case "tif":
        case "xbm":
        case "heic":
        case "arw":
        case "cr2":
        case "k25":
        case "bmp":
            imgType = "image";
            break;
        case "wav":
        case "mp3":
        case "mpga":
        case "wma":
        case "ogg":
        case "aif":
        case "aifc":
        case "aiff":
        case "m4a":
        case "aac":
            imgType = "audio";
            break;
        case "mp4":
        case "mov":
        case "3gp":
        case "ogx":
        case "wmv":
        case "webm":
        case "flv":
        case "avi":
        case "vob":
        case "nsv":
        case "drc":
        case "ogv":
        case "rm":
        case "rmvb":
        case "viv":
        case "asf":
            imgType = "video";
            break;
        case "xla":
        case "xlam":
        case "xls":
        case "xlsb":
        case "xlsm":
        case "xlsx":
        case "application/vnd.google-apps.spreadsheet":
        case "xlt":
        case "xltm":
        case "xltx":
        case "xlw":
        case "csv":
        case "xll":
            imgType = "excel";
            break;
        case "docx":
        case "dot":
        case "doc":
        case "dotm":
        case "txt":
        case "wpd":
        case "odt":
        case "wbk":
        case "docm":
        case "dotx":
        case "docb":
        case "rtf":
        case "dif":
        case "prn":
        case "slk":
            imgType = "doc";
            break;
        case "pdf":
            imgType = "pdf";
            break;
        case "ppt":
        case "pptx":
        case "pptm":
        case "potx":
        case "potm":
        case "ppam":
        case "ppsx":
        case "ppsm":
        case "sldx":
        case "sldm ":
            imgType = "ppt";
            break;
        case "zip":
        case "arj":
        case "cab":
        case "cfs":
        case "cpt":
        case "dar":
        case "dmg":
        case "war":
        case "kgb":
        case "txz":
        case "dd":
        case "ear":
        case "wim":
        case "jar":
        case "rar":
        case "yz1":
            imgType = "zip";
            break;
        case "htm":
        case "html":
            imgType = "htm";
            break;
        default:
            imgType = "doc";
            break;
    }
    return imgType;
};
export const googleDriveMimeFormat =   ['application/vnd.google-apps.audio',
'application/vnd.google-apps.drawing',
'application/vnd.google-apps.drive-sdk',
'application/vnd.google-apps.file',
'application/vnd.google-apps.folder',
'application/vnd.google-apps.form',
'application/vnd.google-apps.fusiontable',
'application/vnd.google-apps.jam',
'application/vnd.google-apps.map',
'application/vnd.google-apps.photo',
'application/vnd.google-apps.presentation',
'application/vnd.google-apps.script',
'application/vnd.google-apps.shortcut',
'application/vnd.google-apps.site',
'application/vnd.google-apps.unknown',
'application/vnd.google-apps.video',
'application/vnd.google-apps.document',
'application/vnd.google-apps.spreadsheet'];

export const filterFavouriteContacts = (needToFilterArray: Array<any>) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    return _.filter(needToFilterArray,
        ((item: any) => {
            let teamMemberFavourite = item.team_members_favourite ? item.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];

            return item.is_favourite === 1 || teamMemberFavourite.includes(userdetails.sip_login_id);
        }));
};

export const SearchFilter = (needTosearchArray: Array<any>, searchText: string) => {
    return needTosearchArray.filter((value: any) => value?.first_name?.toLowerCase()?.startsWith(searchText)
        || value?.last_name?.toLowerCase()?.startsWith(searchText) || value.ext?.toString().toLowerCase()?.startsWith(searchText) ||
        value.team_name?.toLowerCase()?.startsWith(searchText))
    // return _.filter(needTosearchArray, function(data: any) {
    //     let caller_id = data.caller_id || "";
    //     let team_name = data.team_name ||
    //         '';
    //     let email_id = data.email_id || "";
    //     let ext = data.ext || "";
    //     return (((caller_id).toLowerCase()).includes(searchText) ||
    //         (ext.toString()).includes(searchText) || (email_id.toLowerCase()).includes(searchText) ||
    //         (team_name.toLowerCase()).includes(searchText));
    // });

};

export const SearchRecentChat = (needTosearchArray: Array<any>, searchText: string) => {
    return _.filter(needTosearchArray, function (data: any) {
        let caller_id = data.name || "";
        let ext = data.ext || "";
        return (((caller_id).toLowerCase()).includes(searchText) || (ext.toString()).includes(searchText));
    });
};

export const SearchSavedContact = (needTosearchArray: Array<any>, searchText: string) => {
    return _.filter(needTosearchArray, function (data: any) {
        let body_text = data.body_text || "";
        let tocaller_details = data.tocaller_details.caller_id || "";
        let fromcaller_details = data.tocaller_details.caller_id || "";
        return (((body_text).toLowerCase()).includes(searchText.toLowerCase()) ||
            (fromcaller_details.toLowerCase().toString()).includes(searchText.toLowerCase()) ||
            (tocaller_details.toLowerCase().toString()).includes(searchText.toLowerCase()));
    });
};

export const SearchSavedChat = (needTosearchArray: Array<any>, searchText: string) => {
    return _.filter(needTosearchArray, function (data: any) {
        let body_text = data.body_text || "";
        return (((body_text).toLowerCase()).includes(searchText));
    });
};

export const getUserNameForTeam = (data: any) => {
    let sipId = data;
    let userName: any = {};
    let {
        userdetails
    }: LoginState = store.getState().loginReducer;
    if (userdetails.sip_login_id && userdetails.sip_login_id === data) {
        userName.caller_id = userdetails.caller_id;
        userName.ext = userdetails.ext;
        userName.email_id = userdetails.Email;
        userName.ImageURL = userdetails.profile_url;
        userName.jid = `${userdetails.sip_login_id}@${userdetails.host_address}`;
    } else {
        let {
            workContacts,
            teamContacs
        }: any = store.getState().contactReducer;
        if (sipId.includes("con")) {

            teamContacs && teamContacs.map((sList: any) => {
                if (parseInt(sList.team_id) === parseInt(sipId.slice(3))) {
                    return userName = sList;
                } else {
                    return null;
                }
            });
        } else {
            workContacts && workContacts.map((sList: any) => {
                if (parseInt(sList.sip_login_id) === parseInt(sipId)) {
                    return userName = sList;
                } else {
                    return null;
                }
            });
        }

    }

    return userName;
};


export const downloadAttachment = (fileurl: any) => {
    let messageBody = fileurl?.message?.body;
    let filePath = messageBody?.filePath;
    //let fileType = messageBody?.fileType;
    //let fileSize = messageBody?.filesize;
    let fileName = messageBody?.fileName;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", filePath, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
    };
    toastInformation('Success! File downloaded', 'success');
    xhr.send();
};

export const presence = {
    AVAILABLE: "Active",
    BUSY: "Busy",
    DISTRUB: "Do not disturb",
    INVISIBLE: "Away",
    CHAT: "Available",
    AWAY: "Busy",
    DND: "Do not disturb",
    XA: "Invisible",
    OFFLINE: "Offline"
};

export const getTeamMembersnamelist = (teamMembersList: any) => {
    try {
        let {
            workContactsnew
        }: any = store.getState().contactReducer;
        let {
            userdetails
        }: LoginState = store.getState().loginReducer;
        let team_members_details_array: any = [];

        let team_members_array = teamMembersList?.replace(" ", "").split(',');

        _.filter(team_members_array, ((list: any) => {
            if (list) {
                let a_details = workContactsnew[list];
                if (a_details) {
                    team_members_details_array.push(a_details);
                }
                if (!a_details) {
                    if (list === userdetails.sip_login_id) {
                        team_members_details_array.push(userdetails);
                    }
                }


            }

        }));

        return team_members_details_array;
    } catch (err: any) {
        console.log(err, 'err');
    }
};

export const checkLinkMessage = (text: any) => {
    var check: any = false;
    var urls: any = text && text.match(
        /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi
    );
    if (urls) {
        urls.forEach((url: any) => {
            if (text.includes(url)) {
                check = true;
                return;
            } else {
                check = false;
                return;
            }
        });
    } else {
        urls = text && text.match(/(^|[^/])(www\.[\S]+(\b|$))/gim);
        if (urls) {
            urls.forEach((url: any) => {
                if (url.trim() === text.trim()) {
                    check = true;
                    return;
                } else {
                    check = false;
                    return;
                }
            });
        }
    }
    return check;

};
export const SignOut = (history: any) => {
    console.log("LOgout 6")
    //const history1 = useHistory();
    Logout().then(() => {
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if (chatService.socketConnection) {
            let data: any = { status: "0" }
            //chatService.socketConnection.userPresenceStatusUpdate(data);
            chatService.socketConnection.checkPresenceStatus(data);

            console.log(data,"checkPresenceStatus");
            chatService.socketConnection.closeConnection();
            chatService.destroy();
            // chatService.eventEmit = null;
            // chatService.socketConnection = null;=
            sessionStorage.removeItem("userinfo");
            Cookie.clear();
            localStorage.clear();
            sessionStorage.clear();
            // SocketChatService._instance = null;
            unregister();
            //window.location.href = '/login';
            history.push("/login");
            window.location.reload();
        }

    }).catch(() => {
        // console.log('Error 0000');
        history.push("/login");
        window.location.reload();
    });
};
export const blockSignOut = () => {
    console.log("LOgout 60000000")
    Logout().then(() => {
        const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        if(chatService.socketConnection){
          chatService.socketConnection.closeConnection();
          }
        chatService.destroy();
        chatService.eventEmit = null;
        chatService.socketConnection = null;
        Cookie.clear();
        localStorage.clear();
        sessionStorage.clear();
        SocketChatService._instance = null;
        unregister();
        window.location.href = '/login';
        //window.location.reload();

    }).catch(() => {
        // console.log('Error 0000');
        window.location.href = '/login';
       // window.location.reload();
    });



};
export const isEmpty = (value: any) =>
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0);

export const getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        cb(reader.result);
    };
    reader.onerror = (error) => { };
};

export function generateId(name: any) {
    return `${name}_${shortid.generate()}`;
}
export class Cookie {
    static host = window.location.hostname;
    static set(name: any, value: any, days: any) {
        var domain, domainParts, date: any, expires;
        if (days) {
            date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }

        if (this.host.split('.').length === 1) {
            document.cookie = name + "=" + value + expires + "; path=/";
        } else {
            domainParts = this.host.split('.');
            domainParts.shift();
            domain = domainParts.join('.');
            document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
        }
    }
    static get = () => {
        return document.cookie.split(";").map(cookie =>
            cookie.split("=")).reduce((accumulator, [key, value]) => {
                if (key.trim())
                    return ({
                        ...accumulator,
                        [key.trim()]: decodeURIComponent(value)
                    });
                else
                    return "";
            }, {});
    }
    static clear = () => {
        const host = window.location.hostname;
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = domainParts.join('.');
        document.cookie = "ssoToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
        document.cookie = "ssoRefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
        document.cookie = "userinfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        document.cookie = "appSecret=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
        document.cookie = "appId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
        document.cookie = "startTour=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;

    }

    static deleteKey = (name: any) => {
        const host = window.location.hostname;
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = domainParts.join('.');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=${domain}` + domain;

    }
    static deleteRedirectKey = () => {
        const host = window.location.hostname;
        const domainParts = host.split('.');
        domainParts.shift();
        const domain = domainParts.join('.');
        document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
        document.cookie = "meeting_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;

    }
};

export const microConfig: any = {
    localStorageTokenName: "access-token",
    siteUrl: process.env.PUBLIC_URL || window.location.origin + "/onedrivestatus",
    oneDrive: {
        appId: "ab979077-1781-439c-9962-c8849daa3e5f",
        scope:
            // eslint-disable-next-line max-len
            "Files.Read.All offline_access Files.ReadWrite.All Files.ReadWrite Files.ReadWrite.AppFolder Files.ReadWrite.Selected Files.Read.Selected",
        baseUrl: "https://graph.microsoft.com/v1.0"
    }
};

export interface OneDriveItem {
    [k: string]: any;
    name: string;
}


export const mergeAuthHeader = (headersObject: any) => {
    headersObject["Authorization"] =
        "Bearer " + localStorage.getItem(microConfig.localStorageTokenName);
    return headersObject;
};

// remove local storage on logout
export const logout = () => {

};

/**
 * Ond Drive inital request to get tokens
 * @param fullUrl
 * @param options
 */
async function doRequest(fullUrl: string, options: any, token: string) {
    options.headers = {
        "Authorization": "Bearer " + token
    };
    const response = await fetch(fullUrl, options);

    if (response.status === 401) {
        logout();
    }
    return response.json();
}

/**
 * Ond Drive Get Children
 * @param id
 */
export const getChildren = async (id: any = "", token: string): Promise<OneDriveItem[]> => {
    let path: any;

    if (id) {
        path = "/me/drive/items/" + id + "/children";
    } else {
        path = "/me/drive/root/children";
    }
    const response = await doRequest(microConfig.oneDrive.baseUrl + path, {
        method: "get"
    }, token);

    return response.value;
};

/**
 * One Drive Get files in Recursive
 * @param arg
 */
export async function getChildren_recursive(arg: any, token: string): Promise<OneDriveItem[]> {
    const path = "/me/drive/items/" + arg + "/children";
    const response = await doRequest(microConfig.oneDrive.baseUrl + path, {
        method: "get"
    }, token);
    return response.value;
}

export const getParseFileData = (type: any, response: any) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let { sip_login_id } = userdetails;
    let recentArray: any = [];
    try {
        response?.sort(sortDate);
        response?.map((recent: any) => {
            if (recent === null || recent === undefined) return null;
            let parser = new DOMParser();
            let xmlDoc: any = parser.parseFromString(recent.message, "text/xml");

            if (xmlDoc.getElementsByTagName("body").length === 0) {
                return null;
            }

            let receiver: any = "";
            let replyText: any = "";
            let body_text: string = "";
            let message_type_value: string = "";
            let name: string = "unknown sender";
            let image: string;
            let presence: string = "Invisible";
            let ext: string = "";
            let fileSize: any = "";
            let timeStamp: any = recent.timestamp;
            let fileType: any = "";
            let fileName: any = "";
            let summary: string = "";
            let title: string = "";
            let id: any = "";
            let filedetails_text: any = "";
            let isBookmark: any = "";
            let likedUser: any = "";
            let isLike: any = false;

            let time: any = moment(recent.timestamp).format('hh:mm A');

            if (xmlDoc?.getElementsByTagName("message").length > 0) {

                let fromUser: any = xmlDoc.getElementsByTagName("message")[0]?.getAttribute("from");
                receiver = fromUser?.split("/")[0];
                id = xmlDoc.getElementsByTagName("message")[0]?.getAttribute("id");

            }
            if (xmlDoc.getElementsByTagName("save").length > 0) {
                isBookmark = true;
            }

            if (xmlDoc.getElementsByTagName("like").length > 0) {
                likedUser = xmlDoc?.getElementsByTagName("like")[0]?.childNodes.length > 0 ?
                    xmlDoc?.getElementsByTagName("like")[0].childNodes[0]?.nodeValue : "";


                if (likedUser === "") likedUser = [];
                else {
                    likedUser = likedUser?.split(",");

                    likedUser.map((id: any) => {

                        if (id === sip_login_id.toString()) isLike = true;
                    });
                }

            }


            receiver = receiver && receiver?.split("@")[0];
            let {
                allContacs
            } = store.getState().contactReducer;
            let fromcaller_details: any;

            fromcaller_details = getcontactDetail(receiver, allContacs, userdetails);

            let contactDetail: any = getcontactDetail(receiver, allContacs, userdetails);




            if (contactDetail === undefined) return null;

            let teamId: any = "";

            name = contactDetail.sip_login_id ? contactDetail.caller_id : contactDetail.team_name || "unknown sender";
            image = contactDetail.ImageURL || contactDetail.profile_image_url || contactDetail.profile_url || "";
            presence = contactDetail.user_status;
            ext = contactDetail.ext || "";

            if (name.length > 28) {
                name = name.substring(0, 28) + "...";
            }
            /*  if (xmlDoc?.getElementsByTagName("filedetails").length > 0) {
               fileSize = xmlDoc?.getElementsByTagName("filedetails")[0]?.childNodes[0]?.nodeValue;
               console.log(fileSize,"fileSize");
             } */
            if (xmlDoc.getElementsByTagName("body").length > 0) {
                if (xmlDoc?.getElementsByTagName("reply")?.length > 0) {

                    replyText = xmlDoc?.getElementsByTagName("reply")[0]?.childNodes[0]?.nodeValue;
                    body_text = xmlDoc?.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;

                } else {
                    let body = xmlDoc?.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;
                    body_text = body;
                }
            } else {
                body_text = "";
            }



            if (xmlDoc.getElementsByTagName("message-type").length > 0) {
                message_type_value = xmlDoc.getElementsByTagName("message-type")[0].getAttribute("value");

            } else if (xmlDoc.getElementsByTagName("subject").length > 0) {
                message_type_value = xmlDoc?.getElementsByTagName("subject")[0]?.childNodes[0]?.nodeValue;
            } else {
                message_type_value = "TEXT";
            }


            let downloadLink = body_text;
            if (xmlDoc.getElementsByTagName("urlLink").length > 0) {
                summary = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("summary");
                title = xmlDoc.getElementsByTagName("urlLink")[0].getAttribute("title");
            }

            if (xmlDoc.getElementsByTagName("broadcast").length > 0) {
                if (xmlDoc.getElementsByTagName("delay").length > 0) return true;

                let createdUser: any = xmlDoc?.getElementsByTagName("message")[0]?.getAttribute("from");
                let body = xmlDoc?.getElementsByTagName("body")[0]?.childNodes[0]?.nodeValue;

                if (createdUser !== null && createdUser !== undefined) {
                    let BrodCastMessage = JSON.parse(body);
                    if (createdUser.includes(sip_login_id.toString())) {
                        body_text = BrodCastMessage.body2;
                    } else {
                        body_text = BrodCastMessage.body1;
                    }
                }

            }


            if (xmlDoc.getElementsByTagName("filedetails").length > 0) {

                let fileAttribute: any = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileSize');

                if (fileAttribute) {

                    fileSize = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileSize');
                    fileName = xmlDoc.getElementsByTagName("filedetails")[0].getAttribute('fileName');


                } else {

                    if (xmlDoc.getElementsByTagName("filedetails")[0]?.childNodes[0]) {
                        let contentfileSize = xmlDoc.getElementsByTagName("filedetails")[0]?.childNodes[0]?.nodeValue;

                        fileSize = contentfileSize.split("||")[0];

                        let filenameContent: any = body_text.split("/");
                        let filenameFinal: any = filenameContent.splice(-1);


                        fileName = filenameFinal[0];
                    } else {
                        fileSize = 0;
                        fileName = "";
                    }

                }


                if (fileSize === 0) return '0 Byte';
                let decimals: any = 1;
                let k = 1024;
                let dm = decimals + 1 || 3;
                let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                let i = Math.floor(Math.log(fileSize) / Math.log(k));
                fileSize = parseFloat((fileSize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            }
            if (message_type_value === 'FILE') {
                let filename: any = body_text.split("/");
                let filenameFinal: any = filename.splice(-1);
                let filext: any = filenameFinal.toString().split(".").splice(-1);
                fileType = filext[0];
                // fileName = filenameFinal[0];

            }

            /*       if (xmlDoc.getElementsByTagName("filedetails").length > 0) {
                    fileSize= xmlDoc?.getElementsByTagName("filedetails")[0]?.childNodes[0]?.nodeValue;
                    filedetails_text =fileSize;
                    fileSize =fileSize?.split("||")[0];
                    if(fileSize === 0) return '0 Byte';
                    let decimals:any = 1;
                    let k = 1024;
                    let dm = decimals + 1 || 3;
                    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                    let i = Math.floor(Math.log(fileSize) / Math.log(k));
                    fileSize =  parseFloat((fileSize / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
                  }
                  if(message_type_value === 'FILE'){
                    let filename:any = body_text?.split("/");
                    let filenameFinal:any = filename.splice(-1);
                    let filext:any = filenameFinal?.toString().split(".").splice(-1);
                    fileType = filext[0];
                    fileName = filenameFinal[0];
                     
                  } */
            let recentJson = {
                message_type_value,
                body_text,
                replyText,
                name,
                presence,
                ext,
                contactDetail,
                image,
                timeStamp,
                time,
                receiver,
                teamId,
                fileType,
                fileName,
                summary,
                title,
                fileSize,
                id,
                fromcaller_details,
                downloadLink,
                filedetails_text,
                isBookmark,
                likedUser,
                isLike
            };

            recentArray.push(recentJson);
        });

        return recentArray;

    } catch (err) {
        console.log(err, 'err');
    }

};
export const complete_event_status = (start: any, end: any) => {
    let StartDate: any = moment(start).format('YYYY-MM-DD HH:mm:ss ');
    let EndDate: any = moment(end).format('YYYY-MM-DD HH:mm:ss ');
    let currentDate: any = moment().format('YYYY-MM-DD HH:mm:ss ');
    if (EndDate < currentDate) {
        return "Completed";
    } else if (currentDate < StartDate) {
        return "Yet To start";
    } else {
        return "In Progress";
    }

};

export const getdateFormat = (date: any) => {
    var dateRes: any = "";
    dateRes = moment(date).format('hh:mm A')
    return dateRes;
}


export const getGroupDateFormat = (date: any) => {
    var date_group = date;
    var today = moment(new Date()).format("DD MMM YYYY");
    var yesterday = moment().subtract(1, 'days').format('DD MMM YYYY');
    var Tuesday = moment().subtract(2, 'days').format('DD MMM YYYY');
    var Wednesday = moment().subtract(3, 'days').format('DD MMM YYYY');
    var Thursday = moment().subtract(4, 'days').format('DD MMM YYYY');
    var Friday = moment().subtract(5, 'days').format('DD MMM YYYY');
    var Saturday = moment().subtract(6, 'days').format('DD MMM YYYY');

    var weekDay = moment(date, "DD MMM YYYY");

    if (today === date) {
        date_group = "Today";
    } else if ((yesterday === date)) {
        date_group = "Yesterday";
    } else if ((Tuesday === date) || (Wednesday === date) || (Thursday === date) ||
        (Friday === date) || (Saturday === date)) {
        date_group = moment(weekDay).format("dddd");
    } else {
        date_group = date;
    }
    return date_group;
};

export const handleDatePickersnotes = (e: any, neededArray: any) => {
    let startDate = moment(e[0]._d).format("X");
    let EndDate = moment(e[1]._d).format("X");
    if (startDate === EndDate) {
        return _.filter(neededArray, ((data: any) => {
            let notesDate = moment(new Date(parseInt(data.lastModified))).format('YYYY/MM/DD');
            return notesDate === moment(e[0]._d).format('YYYY/MM/DD');
        }));
    } else {
        return _.filter(neededArray, ((data: any) => {
            let notesDate = moment(new Date(parseInt(data.lastModified))).format('YYYY/MM/DD');
            return notesDate >= moment(e[0]._d).format('YYYY/MM/DD') &&
                notesDate <= moment(e[1]._d).format('YYYY/MM/DD');
        }));
    }

};

export const searchNotes = (neededArray: any, searchText: any) => {
    let { userdetails }: LoginState = store.getState().loginReducer;
    let { workContacts }: any = store.getState().contactReducer;
    return _.filter(neededArray, function (data: any) {
        let fileName = data.summary || "";
        let sender: any;
        let owner: any;
        let senders: any;
        if (data.ownerId) {
            senders = _.filter(workContacts,
                ((item) => {
                    return item?.sip_login_id === data?.ownerId;
                }));

            data.ownerId === userdetails.sip_login_id ? owner = userdetails?.caller_id || "" :
                sender = senders[0]?.caller_id || "";
        } else {
            if (data.ownerId.toString() === userdetails.sip_login_id.toString()) {
                owner = userdetails?.caller_id || "";
            } else if (data.ownerId !== userdetails.sip_login_id) {
                senders = _.filter(workContacts,
                    ((item) => {
                        return item?.sip_login_id.toString() === data?.ownerId.toString();
                    }));

                sender = senders[0]?.caller_id || "";
            }

        }

        let Datesearch = moment(new Date(parseInt(data.lastModified))).format("ddd, MMM Do YYYY") || '';
        return (((fileName).toLowerCase()).includes(searchText) ||
            (sender || owner).toLowerCase().includes(searchText) ||
            (Datesearch.toString()).toLowerCase().includes(searchText));

    });
};

export function compareg(a: any, b: any) {

    const caller_idA = a.caller_id ? a.caller_id.toUpperCase().trim() :
        a.team_name ? a.team_name.toUpperCase().trim() : '';

    const caller_idB = b.caller_id ? b.caller_id.toUpperCase().trim() :
        b.team_name ? b.team_name.toUpperCase().trim() : '';

    let comparison = 0;

    if (caller_idA > caller_idB) {
        comparison = 1;
    } else if (caller_idA < caller_idB) {
        comparison = -1;
    }

    return comparison;
}
export function groupingContacts(contactsData: any) {
    let soretedContacts = contactsData.sort(compareg);

    let data = soretedContacts.reduce((r: any, e: any) => {
        let group = (e.caller_id && e.caller_id[0] ? e.caller_id[0].toUpperCase() : '') ||
            (e.team_name && e.team_name[0] ? e.team_name[0].toUpperCase() : '');

        if (!r[group]) r[group] = {
            group,
            ContactList: [e]
        };
        else r[group].ContactList.push(e);

        return r;
    }, {});

    let result = Object.values(data);
    return result;
}
export const scrollIntoView = (data: any) => {

    var element: HTMLElement | any = document.getElementById(data);
    if (element != null) element.scrollIntoView();

};

export const getToken = () => {
    return document.cookie.split(";").map(cookie =>
        cookie.split("=")).reduce((accumulator, [key, value]) =>
        ({
            ...accumulator,
            [key.trim()]: decodeURIComponent(value)
        }), {});
};
export function encryptCodes(content: any, passcode: any) {
    var result: any = [];
    var passLen = passcode.length;
    for (var i = 0; i < content.length; i++) {
        var passOffset = i % passLen;
        var calAscii = (content.charCodeAt(i) + passcode.charCodeAt(passOffset));
        result.push(calAscii);
    }

    return JSON.stringify(result);
}


export function decryptCodes(content: any, passcode: any) {
    let result: any = [];
    var str = '';
    var codesArr = JSON.parse(content);
    var passLen = passcode.length;
    for (var i = 0; i < codesArr.length; i++) {
        var passOffset = i % passLen;
        let calAscii: any = (codesArr[i] - passcode.charCodeAt(passOffset));
        result.push(calAscii);
    }
    for (var j = 0; j < result.length; j++) {
        var ch = String.fromCharCode(result[j]);
        str += ch;
    }

    return str;
}




export const genCalendarObj = (from: any, to: any) => {

    let calendar: any = {
        date: [],
        monthWeekDate: {}
    }
    const fromWd = moment(from).weekday()
    const toWd = moment(to).weekday()
    const fMonth = moment(from).month()
    const tMonth = moment(to).month()
    const tmpFrom = moment(from)
        .subtract(fromWd, 'days')
        .toObject()
    const tmpTo = moment(to)
        .add(6 - toWd, 'days')
        .toObject()

    const daysName = ['s', 'm', 't', 'w', 't', 'f', 's']
    //define date range
    const start = fromWd === 0 ?
        moment(from).toObject() :
        (tmpFrom.months !== fMonth ?
            moment(from).startOf('month').toObject() :
            tmpFrom)
    const end = toWd === 6 ?
        moment(to).toObject() :
        (tmpTo.months !== tMonth ?
            moment(to).endOf('month').toObject() :
            tmpTo)

    const days = moment(end).diff(start, 'days')

    for (let j = 0; j <= days; j++) {
        let tmpDay = moment(start)
            .add(j, 'days')
            .toObject()
        if (moment(tmpDay).isSameOrBefore(end)) {
            let disable = true
            let month = moment(tmpDay).month() + 1
            let week = moment(tmpDay).weeks()
            let dateStr = moment(tmpDay).format('YYYY-MM-DD')

            if (!calendar.monthWeekDate.hasOwnProperty(month))
                calendar.monthWeekDate[month] = {}

            if (!calendar.monthWeekDate[month].hasOwnProperty(week)) {
                calendar.monthWeekDate[month][week] = []
            }

            calendar.monthWeekDate[month][week].push(dateStr)

            if (moment(tmpDay).isBefore(from) || moment(tmpDay).isAfter(to))
                disable = false


            calendar.date.push({
                inputRange: disable,
                year: tmpDay.years,
                month: tmpDay.months + 1,
                day: tmpDay.date,
                dayOfWeek: moment(tmpDay).day(),
                acutulDate: dateStr,
                dayname: daysName[moment(tmpDay).day()],
                week
            })
        }
    }
    return calendar
}

export const getRecentDateFormat = (date: any) => {
    if (date) {
        let new_date = moment(new Date(parseFloat(date))).format("DD MMM YYYY");
        var date_group = new_date;
        var today = moment(new Date()).format("DD MMM YYYY");
        //var Monday = moment().startOf('week').add('d', 1).format('DD MMM YYYY');
        var Tuesday = moment().subtract(2, 'days').format('DD MMM YYYY');
        var Wednesday = moment().subtract(3, 'days').format('DD MMM YYYY');
        var Thursday = moment().subtract(4, 'days').format('DD MMM YYYY');
        var Friday = moment().subtract(5, 'days').format('DD MMM YYYY');
        var Saturday = moment().subtract(6, 'days').format('DD MMM YYYY');
        var yesterday = moment().subtract(1, 'days').format('DD MMM YYYY');

        var weekDay = new Date(new_date);

        if (today === new_date) {
            date_group = moment(new Date(parseFloat(date))).format("hh:mm A");
        } else if ((yesterday === new_date)) {
            date_group = "Yesterday";
        } else if ((Tuesday === new_date) || (Wednesday === new_date) || (Thursday === new_date) ||
            (Friday === new_date) || (Saturday === new_date)) {
            date_group = moment(weekDay).format("dddd");
        } else {
            date_group = new_date;
        }
        return date_group;
    } else {
        return "";
    }
};

export const getNotificationDateFormat = (date: any) => {
    if (date) {
        let new_date = moment(date).format("DD MMM YYYY");
        var date_group = new_date;
        var today = moment(new Date()).format("DD MMM YYYY");
        //var Monday = moment().startOf('week').add('d', 1).format('DD MMM YYYY');
        var Tuesday = moment().subtract(2, 'days').format('DD MMM YYYY');
        var Wednesday = moment().subtract(3, 'days').format('DD MMM YYYY');
        var Thursday = moment().subtract(4, 'days').format('DD MMM YYYY');
        var Friday = moment().subtract(5, 'days').format('DD MMM YYYY');
        var Saturday = moment().subtract(6, 'days').format('DD MMM YYYY');
        var yesterday = moment().subtract(1, 'days').format('DD MMM YYYY');

        var weekDay = new Date(new_date);

        if (today === new_date) {
            date_group = "Today";
        } else if ((yesterday === new_date)) {
            date_group = "Yesterday";
        } else if ((Tuesday === new_date) || (Wednesday === new_date) || (Thursday === new_date) ||
            (Friday === new_date) || (Saturday === new_date)) {
            date_group = moment(weekDay).format("dddd");
        } else {
            date_group = new_date;
        }
        return date_group;
    } else {
        return "";
    }
};

export const getduration = (time: any) => {
    let timeDuration: any;
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    return timeDuration;
}

export const ConvertDuration = (secs: any) => {
    var sec_num = parseInt(secs, 10)
    var hours = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours, minutes, seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "00" || i > 0)
        .join(":")
}

export const tempPushNotification = (messageData: any) => {
    let { chatBellNotification }: BellIconNotification = store.getState().bellNotification;
    new eventService().getBellNotificationCount()
        .then((response: any) => {
            //console.log('result Count--------------->',response); 
            store.dispatch({
                type: Types.BELL_NOTIFICATIONS_COUNT,
                payloads: {
                    bellNotificationCount: response.count + chatBellNotification.length
                }
            })
        })
        .catch((err: any) => {
            console.log("err---", err);
        });
    chatBellNotification.push(messageData);
    store.dispatch({
        type: Types.CHAT_NOTIFICATIONS,
        payloads: chatBellNotification
    })
}


export const compressed_img = (urls: any, filename: any) => {
    var zip = new JSZip();
    var count = 0;
    const zipFilename = "download.zip";
    urls.forEach(function (url: any, i: any) {
        var filename = url.message.body.fileName;
        try {
            const file = JSZipUtils.getBinaryContent(url.message.body.filePath)
            zip.file(filename, file, { binary: true });
            count++;
            if (count === urls.length) {
                zip.generateAsync({ type: 'blob' }).then(function (content: any) {
                    FileSaver.saveAs(content, zipFilename);
                });
            }
        } catch (err) {
            console.log(err);
        }
    });
}

/**
     * To enable notification & mic permission
     */
export const enablePermission = async (data: any) => {
    //let newStream: any = null;
    let gotAudio: any = false;
    let gotVideo: any = false;
    let gotNotify: any = false;
    let gotAudioBlock: any = true;
    let gotVideoBlock: any = true;
    let gotNotiBlock: any = true;
    // let permissionMicroName = "microphone" as PermissionName;
    // let permissionCameraName = "camera" as PermissionName;
    try {
        //if(data!=='leftsidebar' || data!=='callpage'){
        await Notification.requestPermission().then(function (permission) {
            let notfy = permission === 'granted' ? true : permission === 'denied' ? true : false
            enableNotify(notfy);
            permission === 'denied' ? gotNotiBlock = false : permission === 'default' ? gotNotiBlock = true : permission !== 'granted' ? gotNotify = false : gotNotify = true
        });
        // }
    } catch (error) { gotNotify = false; }
    // await navigator.mediaDevices.getUserMedia({ audio: true, video:true }).then((stream:any)=> {
    //     newStream = stream;
    //     gotAudio=true;
    //     gotVideo=true; 
    //     gotAudioBlock=true;
    //     gotVideoBlock=true;

    //     //const stream = videoElem.srcObject;
    //     const tracks = stream.getTracks();
    //     tracks.forEach((track:any) => {
    //         track.stop();
    //     });

    //   }).catch(async function(err) { 
    //     if(newStream!==null){
    //         const tracks = newStream.getTracks();
    //         tracks.forEach((track:any) => {
    //             track.stop();
    //         });
    //     }
    //     if(navigator.userAgent.indexOf("Edg") !== -1 || navigator.userAgent.indexOf("Chrome") !== -1)
    //     {
    //             await navigator.permissions.query({ name: permissionMicroName })
    //             .then(permissionStatus => {
    //                 let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
    //                 enableAudioNotify(sts);
    //                 permissionStatus.state==='denied'?gotAudioBlock=false:permissionStatus.state==='granted'?gotAudio=true:gotAudio=false
    //             });
    //             await navigator.permissions.query({ name: permissionCameraName })
    //             .then(permissionStatus => {
    //                 let sts = permissionStatus.state==='granted'?true:permissionStatus.state==='denied'?true: false
    //                 enableVideoNotify(sts);
    //                 permissionStatus.state==='denied'?gotVideoBlock=false:permissionStatus.state==='granted'?gotVideo=true:gotVideo=false
    //             });
    //     }
    //      //console.log('Audio requesting error is',err); 
    //     });
    let deniedAccess: string = '';
    //    if(gotAudioBlock===false && gotVideoBlock===false && gotNotiBlock===false) {data!=='callpage'?deniedAccess='Microphone,Camera & Notifications':deniedAccess='Microphone'}
    //  else if(gotAudioBlock===false && gotVideoBlock===true && gotNotiBlock===true){ deniedAccess='Microphone'}
    //  else if(gotAudioBlock===false && gotVideoBlock===false && gotNotiBlock===true){ data!=='callpage'?deniedAccess='Microphone & Camera':deniedAccess='Microphone'}
    //  else if(gotAudioBlock===false && gotVideoBlock===true && gotNotiBlock===false){ data!=='callpage'?deniedAccess='Microphone & Notifications':deniedAccess='Microphone'}
    //  else if(gotAudioBlock===true && gotVideoBlock===false && gotNotiBlock===true){ deniedAccess='Camera'}
    //  else if(gotAudioBlock===true && gotVideoBlock===false && gotNotiBlock===false){ deniedAccess='Camera & Notifications'}
    //  else if(gotAudioBlock===true && gotVideoBlock===true && gotNotiBlock===false){ deniedAccess='Notifications'}
    //  else {deniedAccess='';}
    if (gotNotiBlock === false) { deniedAccess = 'Notifications' }
    else { deniedAccess = ''; }
    //   console.log('gotAudioBlock -----', gotAudioBlock);
    //   console.log('gotVideoBlock -----', gotVideoBlock);
    //   console.log('gotNotiBlock -----', gotNotiBlock);
    window.location.pathname !== '/' && window.location.pathname !== '/login' && window.location.pathname !== '/chats' && deniedAccess !== '' && Blocknotifications('top', deniedAccess);

    if (gotNotify === true) {
        const inputOptions = {
            userName: 'New Message From Worktual',
            message: 'Great! we have enabled notifications'
        };
        showBrowserNotification(inputOptions, 'enablenoti');
    }
    let arrayVal = { 'gotAudio': gotAudio, 'gotVideo': gotVideo, 'gotNotify': gotNotify, 'gotAudioBlock': gotAudioBlock, 'gotVideoBlock': gotVideoBlock, 'gotNotiBlock': gotNotiBlock }
    return arrayVal;
}

/**
   * To enable safari notification & mic permission
   */
export const enablePermissionSafari = async (data: any) => {
    if (navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1) {
        //let newStream: any = null;
        let setAudio: any = false;
        let setVideo: any = false;
        let setNotify: any = false;
        try {
            await Promise.resolve(Notification.requestPermission()).then(function (permission) {
                if (permission !== undefined) {
                    let notfy = permission === 'granted' ? true : permission === 'denied' ? true : false;
                    enableNotify(notfy);
                    permission === 'denied' ? setNotify = false : permission === 'default' ? setNotify = true : permission !== 'granted' ? setNotify = false : setNotify = true;
                } else {
                    setNotify = true; enableNotify(setNotify);
                }
            });
        } catch (error) {
            setNotify = false;
            throw error;
        }
        //   await navigator.mediaDevices.getUserMedia({ audio: true, video:true }).then((stream:any)=> {  
        //     newStream = stream;
        //     setAudio=true;
        //     setVideo=true; 
        //     // const inputOptions = {
        //     //   userName: 'New Message From Worktual',
        //     //   message: 'Great! we have enabled notifications'
        //     // };
        //     // showBrowserNotification(inputOptions, 'enablenoti');
        //      const tracks = stream.getTracks();
        //      tracks.forEach((track:any) => {
        //          track.stop();
        //      });
        //   }).catch(async function(err) { 
        //     if(newStream!==null){
        //         const tracks = newStream.getTracks();
        //         tracks.forEach((track:any) => {
        //             track.stop();
        //         });
        //     }

        //     if(err.message==="The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."){
        //       //window.location.reload();
        //       let deniedAccess='Microphone & Camera';
        //       setAudio=false;
        //       setVideo=false; 
        //       window.location.pathname !== '/login' && window.location.pathname !== '/' && Blocknotifications('top',deniedAccess);
        //     }
        //     });
        let arrayVal = { 'setNotify': setNotify, 'setAudio': setAudio, 'setVideo': setVideo }
        return arrayVal;
    } else {
        window.location.pathname !== '/login' && window.location.pathname !== '/login' && window.location.pathname !== '/' && enablePermission('leftsidebar');
    }


}

export const urlify = (text: any) => {
const urlRegex = /https?:\/\/[^\s<]+|www\.[^\s<]+/gi;

// Replace URLs with <a> tags

const LinkText = text?.replace(urlRegex, (url:any) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return `<a href="${url}" target="_blank">${url}</a>`;
  } else if (url.startsWith("www.")) {
    return `<a href="http://${url}" target="_blank">${url}</a>`;
  } else {
    return url;
  }
});
    const lines:any = LinkText?.split('<br>');
    const SplittedLinkWithText = lines && lines?.map((line: any) => line?.trim() ? `<p>${line}</p>` : '').join('');
    return SplittedLinkWithText;


    /* previous logic for link  */ 

    // var var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    // let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
    // const gmail_collection = regex.test(text);
    // const gmail_collection1 = urlRegex.test(text);
    // if (gmail_collection && !gmail_collection1) {
    //     return text?.replace(regex, function (url: any, b: any, c: any) {
    //         return '<a target="_blank" href="mailto:' + url + ' ">' + url + '</a>';
    //     })
    // }
    // const collection = text?.replace(/<\/?a[^>]*>/g, " ");
    // return collection?.replace(urlRegex, function (url: any, b: any, c: any) {
    //     var url2 = (c === 'www.') ? 'http://' + url : url;
    //     return '<a target="_blank" href="' + url2?.replace(/(<([^>]+)>)/gi, "") + ' ">' + url + '</a>';
    // })

}

export const urlifySW = (arr: any, text: any) => {
    for (var i = 0; i < arr.length; i++) {
        let callId = '@' + arr[i].caller_id
        const regexs = new RegExp('(' + callId + ')', 'gi');
        text = text.replace(regexs, function (url: any) {
            return '<a href="' + url + '">' + url + '</a>';
        })
    }
    return text;
}


export const getCaretCharacterOffsetWithin = (element: any) => {
    var caretOffset = 0;
    var doc = element.ownerDocument || element.document;
    var win = doc.defaultView || doc.parentWindow;
    var sel;
    if (typeof win.getSelection !== "undefined") {
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
            var range = win.getSelection().getRangeAt(0);
            var preCaretRange = range.cloneRange();
            preCaretRange.selectNodeContents(element);
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            caretOffset = preCaretRange.toString().length;
        }
    } else if ((sel = doc.selection) && sel.type !== "Control") {
        var textRange = sel.createRange();
        var preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;
}

export const LeftSavedChatClear = () => {
    const chatSocket = new SocketChatService(userInfo().fromID, userInfo().domainId);
    setTimeout(() => {
        chatSocket.socketConnection?.getSaveChatList({});
    }, 500)

}
export const closeVideoRinging = () => {
    var videoRinger: any = document.getElementById("videoringer");
    var promoseVide:any = videoRinger.pause();
    store.dispatch({
        type: Types.VIDEO_MEET_RING_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isRingvideo: false

        }
    })
}

export const closeVideoCallRinging = () => {
    var videoRinger: any = document.getElementById("videoringer");
    var promoseVide:any = videoRinger.pause();
    store.dispatch({
        type: Types.VIDEO_CALL_REQUEST_NOTIFICATION,
        payload: {
            meetingDetails: {},
            isVideocallRingvideo: false
        }
    })
}

export const enableNotify = (data: boolean) => {
    store.dispatch({
        type: Types.ENABLE_NOTIFICATION,
        payload: {
            notifyPermission: data
        }
    })
}
export const enableAudioNotify = (data: boolean) => {
    store.dispatch({
        type: Types.AUDIO_NOTIFICATION,
        payload: {
            audioPermission: data

        }
    })
}
export const enableVideoNotify = (data: boolean) => {
    store.dispatch({
        type: Types.VIDEO_NOTIFICATION,
        payload: {
            videoPermission: data
        }
    })
}

export const jenkinMessageClose = () => {
    store.dispatch({
        type: Types.JENKINS_MESSAGE,
        payload: {
            jenkinMessage: false
        }
    })
}
export const newTagUnread = (data: any) => {
    let { newTagMessage }: chatwindowDetails = store.getState().chatWindowReducer;
    newTagMessage.push(data);
    store.dispatch({
        type: Types.NEW_TAG_MESSAGE,
        payload: {
            newTagMessage: newTagMessage
        }
    })
}
var SAMPLE_RATE = 30000; // 3 seconds
var lastSample = Date.now();
export const sleepDetect = () => {
    if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
        // Code here will only run if the timer is delayed by more 2X the sample rate
        // (e.g. if the laptop sleeps for more than 3-6 seconds)

        console.log("<<<<<<Sleep detect>>>>>")

        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = 'Upcoming';
        data.searchText = '';
        data.sort = '1';
        getMeetingLists(data);
        const curDate = new Date();
        getMeetingByDate(moment(curDate).format("YYYY-MM-DD"));

    }
    lastSample = Date.now();
    setTimeout(sleepDetect, SAMPLE_RATE);
}

export function getTimeDiffer(time: any) {
    var difference = new Date(Number(time)).getTime() - new Date().getTime();
    var minutesDifference = Math.floor(difference / 1000 / 60);
    //console.log(minutesDifference,"minutesDifference")
    return minutesDifference;
};

export function getTooltipTime(time: any) {
    let date = new Date(time)
    let formatDate: any = get_recent_date(time);
    time = formatDate.split(" ");

    if (time[4] === "Today") {
        time = "Today at " + time[2] + time[3]
    } else if (time[4] === "Yesterday") {
        time = "Yesterday at " + time[2] + time[3]
    } else {
        time = moment(new Date(date)).format("DD MMM") + " at " + time[2] + time[3]
    }
    return time;

}
export const SearchConversationFilter = (needTosearchArray: Array<any>, searchText: string) => {
    return needTosearchArray.filter((value: any) => value?.message?.messageType === 'TEXT' && value?.message?.body?.toLowerCase()?.includes(searchText?.toLowerCase())
    )
};

export const urlifyATmention = (arr: any, text: any) => {
    const mention_mem: Array<any> = (arr?.mentionID !== '' || arr?.mentionID !== undefined) ? getTeamMembersnamelist(arr?.mentionID) : [];
    if (Array.isArray(mention_mem) && mention_mem?.length > 0) {
        for (var i = 0; i < mention_mem?.length; i++) {
            let callerID = mention_mem[i].caller_id.toString()
            var re = new RegExp(`${"@" + (callerID)}`, 'g');
            text = text.replace(re, function (url: any) {
                return '<span class="atglobalMention">@' + callerID + '</span>';
            })
        }
    }
    return text;
}

export  const playNotificationSound = async () => {  
    
    let MsgNotificationSound= import("../styles/images/messagenotification.mp3");   
    var msgnotiaudio = new Audio((await MsgNotificationSound).default)
   //await msgnotiaudio.play();
   msgnotiaudio.pause();
   msgnotiaudio.addEventListener("canplaythrough", () => {
    msgnotiaudio.play().catch(e => {
        console.log('error: ',e);
    })
 });
}

/* 
Box
BOX particular FileDetials
*/

export const boxFileDetails=async(fileId:string,path?:string)=> {

    let boxKey:any = localStorage.getItem("boxStorageValue");
    if(boxKey) {
        let parseboxToken: any = JSON.parse(boxKey).access_token;
        const headers = {
          Authorization: "Bearer " + parseboxToken,
          "Content-Type": "application/json"
        };
        let apiUrl = '?fields=shared_link';
        if(path) {
            apiUrl=''
        }
    
       return  await axios.get(`https://api.box.com/2.0/files/${fileId}${apiUrl}`,{headers}).then((response:any)=> {
        return response.data;
        })
        .catch((err:any)=> {
            console.log("error in get file ",err);
            return false;
        });
    }
    else {
        return false;
    }
}
/* 
get Box all Folders
*/
export const getBoxFolder = async () => {
    let boxKey:any = localStorage.getItem("boxStorageValue");
    if(boxKey) {
        let parseboxToken: any = JSON.parse(boxKey).access_token; 
        try {
            const headers = {
            Authorization: "Bearer " + parseboxToken,
            "Content-Type": "application/json"
            };
            return await axios.get(`${config().BOX_BASE_URL}folders/0?${config().queryBoxUrl}`,{ headers }).then((response:any)=> {
                return response.data.item_collection;
            })
        } catch (error) {
            console.log("errrr------", error);
            return false;
        }
    }
    else {
        return false;
    }
};
/* 
Box search Api 
*/
export const getBoxAPISearch=async(searchKey:String)=> {
    let boxKey:any = localStorage.getItem("boxStorageValue");
    let parseboxToken: any = JSON.parse(boxKey)?.access_token;
    const headers = {
      Authorization: "Bearer " + parseboxToken,
      "Content-Type": "application/json"
    };
    return await requestBox(searchKey,headers);   
}

async function requestBox(searchKey:any, headers:any) {
    return await axios.get(`${config().BOX_BASE_URL}search?offset=0&query=${searchKey}&limit=50&${config().queryBoxUrl}`, {headers}).then((resp:any)=> {
        return resp.data;
    })
    .catch((err:any)=> {
        console.log('err',err);
        return err;
    })

}

/* 
BOX OAUTH

*/
export const boxOauthHitting=async()=> {
  console.log(" BoxSuccess use effect--------------");
 let windowSearch = window.location.search;
 let boxSecretCode = new URLSearchParams(windowSearch).get("code");
  if (boxSecretCode) {
     let payload = {
        grant_type: 'authorization_code',
        client_id: config().BOX_CLIENT_ID,
        client_secret: config().BOX_CLIENT_SECRET,
        code: boxSecretCode
      };
     let headers = {
      "Content-Type": 'application/json'
      };

     return await axios.post('https://api.box.com/oauth2/token',payload, {headers} ).then((resp:any)=>{
         if(resp.data) {
            try {
               if(resp.data.access_token) {
                        localStorage.setItem('boxStorageValue', JSON.stringify(resp.data));
                        return 'successfully logged to box. Please close the window.....';
                 }
            } catch (error) {
                    console.log("err",error);
                    return 'getting error. please log in again';
                 }
            
          }
        })
        .catch((err:any)=> {
            console.log("error box-----------",err)
        })
   }

}

/* Evernote OAUTH */

export const everNoteOauth = async()=> {
    let boxAuthUrl = "https://tpicb.worktual.co.uk/evernote/oauth";
    window.open(boxAuthUrl,
      "sharer",
      "toolbar=0,status=0,width=900,height=518,top=120,resizable=0 left=100,right=100"
    );
}
/* 
 get Evernote notebooks
*/
export const getEverNotebooks = async()=> {
    const{userdetails}:LoginState = store.getState().loginReducer;
    const headers = { 'Content-type':'application/json' };
   return await axios.get(`https://tpicb.worktual.co.uk/evernote/noteBooks/${userdetails.sip_login_id}`, {headers})
    .then((response:any)=> {
       return response.data;
    })
    .catch((err:any)=> {
        console.log("err",err);
    })
}
/*
save evernote note
*/
export const saveNote = async(noteData:any)=> {
    const{userdetails}:LoginState = store.getState().loginReducer;
    noteData.sipid = userdetails.sip_login_id;
  const headers = {
    'Content-type':'application/json'
  }

   return await axios.post('https://tpicb.worktual.co.uk/evernote/createNotes',noteData, {headers})
    .then((response:any)=> {
       return response.data;
      
    })
    .catch((err:any)=> {
        console.log("err",err);
    })
}

/* get EverNotes note list data */

export const getNotes = async ()=>{
    const headers = {
        'Content-type':'application/json'
    }
   return await axios.get('https://tpicb.worktual.co.uk/evernote/getNotes', {headers})
    .then((response:any)=> {
       return response.data;
    })
    .catch((err:any)=> {
        console.log("err",err);
    })
}

/*  
store Evernote Token , userid, expiry to MYSQL DB
*/
export const storeOauthToken = async ()=>{
    let data:any = localStorage.getItem('authorization');
    var decoded:any =  data && jwt_decode(data);

    let evernotUserId:any = new URLSearchParams(window.location.search).get("user_id");
    let evernoteOauth = new URLSearchParams(window.location.search).get("accessToken");
    let evernoteExpiry = new URLSearchParams(window.location.search).get('expiry');

    const headers = {
        'Content-type':'application/json'
    }
    if(decoded  && evernoteOauth) {
        
        let payload = {
            "sip_login_id": decoded.sipLoginId,
            "companyId": decoded.company_id,
            "evernote_token": evernoteOauth,
            "evernote_expiry": evernoteExpiry,
            "evernote_userid": evernotUserId
        }
        
        return await axios.post('https://tpicb.worktual.co.uk/evernote/evernoteStore', payload, {headers})
        .then((response:any)=> {
            if(response.data.statusCode === 200) {
                localStorage.setItem('evernoteuserid',response.data.result.evernote_userid);
                    window.close();
            }
            else {
                toastInformation(response.data.message, 'failure');
               window.close();
            }   
         })
         .catch((err:any)=> {
             console.log("err",err);
         })
    }   
    else {  window.close(); }

}